<template>
  <autocomplete
    ref="autocomplete"
    :url="url"
    anchor="name"
    param="query"
    label="name"
    :classes="classes"
    :on-input="onInput"
    :options="options"
    :on-select="select"
    :debounce="200"
    :custom-params="{ exclude: exclude }"
    :placeholder="placeholder"
    :on-should-render-child="renderChild"
    :on-should-get-data="doAjax"
  />
</template>

<script>
import Autocomplete from 'vue2-autocomplete-js'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'Suggest',

  components: {
    Autocomplete,
  },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    url: {},
    clearOnSelect: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: () => {
        return trans('core.search') + '...'
      },
    },
    exclude: {},
    showTop: {
      default: true,
    },
    createNewStudent: {
      required: false,
      default: true,
    },
  },

  data () {
    return {
      baseClasses: {
        input: 'form-control',
        list: 'datalist',
      },
      options: [],
      empty: true,
      value: null,
    }
  },

  computed: {

    classes () {
      return {
        input: 'form-control',
        list: this.showTop ? 'datalist-top' : 'datalist',
      }
    },

  },

  methods: {
    select (data) {
      if (data.id == -1) {
        this.$emit('select_new_student', this.value)
      } else {
        this.$emit('select', data.id, data.name)
      }

      if (this.clearOnSelect === true) {
        this.$refs.autocomplete.setValue('')
      }
    },

    // override the do ajax from the library to support POST request to our endpoint
    doAjax (val) {
      this.value = val
      // this is the autocomplete object
      const autocompleteRef = this.$refs.autocomplete

      // Callback Event
      autocompleteRef.onBeforeAjax ? autocompleteRef.onBeforeAjax(val) : null

      // Compose Params
      const params = typeof autocompleteRef.customParams === 'undefined' ? {} : autocompleteRef.customParams
      params[autocompleteRef.param] = val

      const config = {
        onUploadProgress: progressEvent => {
          if (data.lengthComputable && autocompleteRef.onAjaxProgress) {
            autocompleteRef.onAjaxProgress(data)
          }
        },
      }

      // Init Ajax
      const postData = {
        url: autocompleteRef.url,
        params,
        courseId: this.courseId,
        lessonId: this.lessonId,
      }

      this.$store.dispatch('suggest_new_student', { courseId: this.courseId, lessonId: this.lessonId, postData }).then(response => {
        // Callback Event
        const data = response.data
        autocompleteRef.onAjaxLoaded ? autocompleteRef.onAjaxLoaded(data) : null
        autocompleteRef.json = autocompleteRef.process ? autocompleteRef.process(data) : data

        if ((autocompleteRef.json.length == 0 || (this.value != null && this.value !== '')) && this.createNewStudent) {
          const addStudentString = Lang.get('core.add_object', { object: Lang.get('core.student') })

          autocompleteRef.json.push({
            id: -1,
            name: addStudentString + ': ' + this.value,
          })
        }
      }).catch(error => defaultErrorMessage(error))
      // not supported from library: custom request headers
    },

    renderChild (data) {
      if (data.id == -1) {
        return '<em>' + data.name + '</em>'
      }
      return data.name
    },

    clear () {
      this.$refs.autocomplete.setValue('')
      this.$emit('clear')
      this.empty = true
    },

    onInput (input) {
      if (input == '') {
        this.$emit('clear')
        this.empty = true
      }
      this.empty = false
    },
  },
}
</script>

<style>

    .autocomplete-wrapper .datalist > ul {
        width: 100%;
        max-height: 300px;
        overflow-y: auto;

    }

    .autocomplete-wrapper .datalist-top > ul {

        position: absolute;
        top: auto;
        bottom: 100%;
        margin-bottom: 2px;
        display: block;
        width: 100%;
        max-height: 300px;
        overflow-y: auto;
    }

    .autocomplete ul li.focus-list a {
        background: #25167a;
    }

    .autocomplete-wrapper {
        position: relative;
    }
</style>
